import { FC } from 'react';

export const NotificationSolid: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 2C12.5523 2 13 2.44772 13 3V4.58296C15.8377 5.05904 18 7.527 18 10.5V15.1716C18 15.4368 18.1054 15.6911 18.2929 15.8787L19.7071 17.2929C19.9931 17.5789 20.0787 18.009 19.9239 18.3827C19.7691 18.7564 19.4045 19 19 19H15C15 20.6569 13.6569 22 12 22C10.3432 22 9.00003 20.6569 9.00003 19H5.00003C4.59557 19 4.23093 18.7564 4.07615 18.3827C3.92137 18.009 4.00692 17.5789 4.29292 17.2929L5.70714 15.8787C5.89467 15.6911 6.00003 15.4368 6.00003 15.1716V10.5C6.00003 7.527 8.16232 5.05904 11 4.58296V3C11 2.44772 11.4477 2 12 2Z"
			fill="currentColor"
		/>
	</svg>
);
